import Segment from '../Segment/Segment';
import { clients } from './ClientSwitcher.data';
import { Wrapper } from './ClientSwitcher.style';

export type ClientSwitcherProps = {};

const subdomains: Record<string, Site> = {
  admin: 'admin',
  platform: 'platform',
  'v2.app': 'web',
};

export function ClientSwitcher(props: ClientSwitcherProps) {
  // subdomain
  const subdomain = window.location.hostname.split('.')[0];
  const site = subdomains[subdomain] || 'web';

  function onChange(value: string) {
    const client = clients.find((client) => client.value === value);
    if (!client) return;
    document.location.href = client.url;
  }

  return (
    <Wrapper className='ClientSwitcher-wrapper' data-testid='ClientSwitcher-wrapper'>
      <Segment value={site} data={clients} onChange={onChange} maxWidth={400} />
    </Wrapper>
  );
}

export default ClientSwitcher;
